export default "__VITE_ASSET__368e8585__"